
export default [
    {
        path: "/committees",
        name: "committees",
        component: () => import(/* webpackChunkName: "committees" */ "../views/committees/Committees.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/committees/join",
        name: "join_committees",
        props: {
          join: true
        },
        component: () => import(/* webpackChunkName: "committees" */ "../views/committees/Committees.vue"),
        meta: { requiresAuth: true }
    }
]